export default "__VITE_ASSET__5b4975e5__"